import enAU from "./en-AU";

export default {
  "en-AU": enAU,
};
